import { render, staticRenderFns } from "./UploadTable.vue?vue&type=template&id=1b1be73b&scoped=true&"
import script from "./UploadTable.vue?vue&type=script&lang=js&"
export * from "./UploadTable.vue?vue&type=script&lang=js&"
import style0 from "./UploadTable.vue?vue&type=style&index=0&id=1b1be73b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1be73b",
  null
  
)

export default component.exports